import { createSlice } from '@reduxjs/toolkit';
import { revertAll } from './userReducer';

const initialState = null;

const rewardsLastEvaluatedKeyReducer = createSlice({
	name: 'rewardsLastEvaluatedKey',
	initialState: null,
	reducers: {
		setRewardsLastEvaluatedKeyData(state, action) {
			return action.payload;
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(revertAll, () => initialState);
	},
});

export const { setRewardsLastEvaluatedKeyData } = rewardsLastEvaluatedKeyReducer.actions;
export default rewardsLastEvaluatedKeyReducer;
